import { ICheckServiceResponse } from '../../../repositories/monolith-python/v1/check-service';
import { ICheckoutInfo } from '../../../redux/reducers';
import { defaultTo } from 'ramda';
import { mapAutoProlongInfo } from './mapAutoProlongInfo';
import { mapServicesUnavailableMessage } from './mapServicesUnavailableMessage';
import { mapWriteOffInfo } from './mapWriteOffInfo';
import { mapWriteOffWithoutDiscountInfo } from './mapWriteOffWithoutDiscountInfo';

export function mapCheckoutInfo(response: ICheckServiceResponse): ICheckoutInfo {
  const {
    isAvailable,
    actionDescription,
    autoProlongInfo,
    insufficientFunds,
    unavailableCheckServiceMessage,
    writeOff,
    writeOffWithoutDiscount,
  } = response || {};

  return {
    isPurchaseAvailable: defaultTo(false, isAvailable),
    submitText: defaultTo('Разместить', actionDescription),
    isInsufficientFunds: defaultTo(false, insufficientFunds),
    autoProlongInfo: mapAutoProlongInfo(autoProlongInfo),
    servicesUnavailableMessage: mapServicesUnavailableMessage(unavailableCheckServiceMessage),
    writeOffInfo: mapWriteOffInfo(writeOff),
    writeOffWithoutDiscountInfo: mapWriteOffWithoutDiscountInfo(writeOffWithoutDiscount),
  };
}
